/** Chave de localStorage do estado aberto/fechado de um submenu. O id do usuário é único entre tenants (autoincrement). */
export function chaveSubmenu(usuarioId: number | undefined, grupoKey: string): string {
  return `vinya:nav-submenu:${usuarioId ?? 0}:${grupoKey}`;
}
